var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container", class: "step" + _vm.step }, [
    !_vm.isMobile
      ? _c("p", { staticClass: "info" }, [
          _vm._v(
            "\n       Global Brands, Local Retailers, One Entrepreneur Dream!\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isMobile
      ? _c("p", { staticClass: "info-sub" }, [
          _vm._v(
            "\n      Shop smarter. | Flexible payments. | No MOQ & Free shipping.\n    "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.loginType == "login"
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.googleLogin,
                expression: "googleLogin"
              }
            ],
            staticClass: "login"
          },
          [
            _c("img", {
              staticClass: "logo login-logo",
              attrs: {
                src:
                  "https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"
              }
            }),
            _vm._v(" "),
            _c(
              "el-form",
              { ref: "loginForm", attrs: { model: _vm.loginForm } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "email",
                      rules: [
                        {
                          required: true,
                          message: "Please enter the email",
                          trigger: "blur"
                        },
                        // {
                        //   type: 'email',
                        //   message: 'Please enter the correct email address',
                        //   trigger: ['blur', 'change'],
                        // },
                        { validator: _vm.checkEmail, trigger: [] }
                      ]
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "cust-input",
                      attrs: {
                        "auto-complete": "new-password",
                        oninput: "if(value){value=value.toLowerCase()}",
                        onblur: "if(value){value=value.trim()}",
                        placeholder: "Email"
                      },
                      model: {
                        value: _vm.loginForm.email,
                        callback: function($$v) {
                          _vm.$set(_vm.loginForm, "email", $$v)
                        },
                        expression: "loginForm.email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "password",
                      rules: {
                        required: true,
                        message: "Please enter the password",
                        trigger: "blur"
                      }
                    }
                  },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "cust-input",
                        attrs: {
                          "auto-complete": "new-password",
                          type: _vm.passw,
                          placeholder: "Password"
                        },
                        model: {
                          value: _vm.loginForm.password,
                          callback: function($$v) {
                            _vm.$set(_vm.loginForm, "password", $$v)
                          },
                          expression: "loginForm.password"
                        }
                      },
                      [
                        _c(
                          "i",
                          {
                            attrs: { slot: "suffix" },
                            on: { click: _vm.showPass },
                            slot: "suffix"
                          },
                          [
                            _vm.passw == "password"
                              ? _c("img", {
                                  staticStyle: {
                                    width: "16px",
                                    height: "16px"
                                  },
                                  attrs: {
                                    src: require("../../assets/img/icon-hide.png"),
                                    alt: ""
                                  }
                                })
                              : _c("img", {
                                  staticStyle: {
                                    width: "16px",
                                    height: "16px"
                                  },
                                  attrs: {
                                    src: require("../../assets/img/icon-show.png"),
                                    alt: ""
                                  }
                                })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", [
                  _c(
                    "div",
                    {
                      staticClass: "forget-btn",
                      on: {
                        click: function($event) {
                          return _vm.$router.push("/forget")
                        }
                      }
                    },
                    [_vm._v("\n            Forgot password?\n          ")]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "login-btn" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { loading: _vm.loginLoading, type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitForm("loginForm")
                          }
                        }
                      },
                      [_vm._v("Login")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn1 cust-button",
                        on: { click: _vm.signUp }
                      },
                      [_vm._v("Register")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c("GoogleLogin", {
                      on: { googleCallBack: _vm.googleCallBack }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.loginType == "register"
      ? _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.reging,
                expression: "reging"
              }
            ],
            staticClass: "register"
          },
          [
            _vm.step == 0
              ? _c(
                  "div",
                  [
                    _c("img", {
                      staticClass: "logo reg-logo",
                      attrs: {
                        src:
                          "https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "registerForm",
                        staticClass: "demo-ruleForm",
                        attrs: { model: _vm.registerForm, rules: _vm.rules }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "flex cust-form-item",
                            attrs: {
                              prop: "username",
                              rules: {
                                required: true,
                                validator: _vm.userNameCheck,
                                trigger: "blur"
                              }
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "cust-input",
                              attrs: {
                                placeholder: "First Name",
                                oninput: "if(value){value=value.toLowerCase()}",
                                onblur: "if(value){value=value.trim()}"
                              },
                              model: {
                                value: _vm.registerForm.firstName,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "firstName", $$v)
                                },
                                expression: "registerForm.firstName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "flex cust-form-item",
                            attrs: {
                              prop: "username",
                              rules: {
                                required: true,
                                validator: _vm.userNameCheck2,
                                trigger: "blur"
                              }
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "cust-input",
                              attrs: {
                                placeholder: "Last Name",
                                oninput: "if(value){value=value.toLowerCase()}",
                                onblur: "if(value){value=value.trim()}"
                              },
                              model: {
                                value: _vm.registerForm.lastName,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "lastName", $$v)
                                },
                                expression: "registerForm.lastName"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "cust-form-item",
                            attrs: {
                              prop: "email",
                              rules: [
                                {
                                  required: true,
                                  message: "Please enter the email",
                                  trigger: "blur"
                                },
                                // {
                                //   type: 'email',
                                //   message: 'Please enter the correct email address2',
                                //   trigger: ['change']
                                // },
                                { validator: _vm.checkEmail, trigger: "blur" }
                              ]
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "cust-input",
                              attrs: {
                                placeholder: "Business Email",
                                oninput: "if(value){value=value.toLowerCase()}",
                                onblur: "if(value){value=value.trim()}"
                              },
                              model: {
                                value: _vm.registerForm.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "email", $$v)
                                },
                                expression: "registerForm.email"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        false
                          ? _c(
                              "el-form-item",
                              { staticClass: "flex" },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "Verification Email Code"
                                  },
                                  model: {
                                    value: _vm.registerForm.code,
                                    callback: function($$v) {
                                      _vm.$set(_vm.registerForm, "code", $$v)
                                    },
                                    expression: "registerForm.code"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn2",
                                    on: { click: _vm.getCode }
                                  },
                                  [_vm._v(_vm._s(_vm.timeValue))]
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "flex cust-form-item cust-form-item2",
                            attrs: { prop: "phone" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "cust-input_clear_border",
                                attrs: {
                                  filterable: "",
                                  placeholder: "+ Country Code"
                                },
                                on: { change: _vm.codeChange },
                                model: {
                                  value: _vm.codeObject,
                                  callback: function($$v) {
                                    _vm.codeObject = $$v
                                  },
                                  expression: "codeObject"
                                }
                              },
                              [
                                _c("template", { slot: "empty" }, [
                                  _c(
                                    "p",
                                    { staticStyle: { display: "none" } },
                                    [_vm._v("no data")]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.options, function(item, index) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: index,
                                      attrs: { label: item.text, value: item }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticStyle: { float: "left" } },
                                        [_vm._v(_vm._s(item.text))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            float: "right",
                                            color: "#8492a6",
                                            "font-size": "13px"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.value))]
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("el-divider", {
                              staticClass: "cust-divider",
                              attrs: { direction: "vertical" }
                            }),
                            _vm._v(" "),
                            _c("el-input", {
                              staticClass: "cust-input_clear_border",
                              staticStyle: { width: "140%" },
                              attrs: { placeholder: "Phone" },
                              on: { input: _vm.changePhone },
                              model: {
                                value: _vm.registerForm.phone,
                                callback: function($$v) {
                                  _vm.$set(_vm.registerForm, "phone", $$v)
                                },
                                expression: "registerForm.phone"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "cust-form-item",
                            attrs: {
                              prop: "password",
                              rules: {
                                validator: _vm.handlePasswordLevel,
                                trigger: "change"
                              }
                            }
                          },
                          [
                            _c(
                              "el-popover",
                              {
                                ref: "popover",
                                attrs: {
                                  placement: _vm.isMobile
                                    ? "top-start"
                                    : "right",
                                  width: "200",
                                  trigger: "focus"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    style:
                                      "color:" + _vm.levelColor[_vm.levelStatus]
                                  },
                                  [
                                    _c("i", {
                                      class: _vm.levelClass[_vm.levelStatus]
                                    }),
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.levelNames[_vm.levelStatus]
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "10px"
                                    }
                                  },
                                  _vm._l(_vm.levelNames, function(item, id) {
                                    return id > 0
                                      ? _c("el-progress", {
                                          key: id,
                                          staticStyle: { width: "33%" },
                                          attrs: {
                                            percentage:
                                              id > _vm.levelStatus
                                                ? 0
                                                : id < _vm.levelStatus
                                                ? 100
                                                : _vm.levelPercent,
                                            "show-text": false,
                                            color:
                                              _vm.levelColor[_vm.levelStatus]
                                          }
                                        })
                                      : _vm._e()
                                  }),
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-input",
                              {
                                directives: [
                                  {
                                    name: "popover",
                                    rawName: "v-popover:popover",
                                    arg: "popover"
                                  }
                                ],
                                staticClass: "cust-input",
                                attrs: {
                                  type: _vm.passw,
                                  autocomplete: "new-password",
                                  placeholder: "Password"
                                },
                                on: { focus: _vm.changeType },
                                model: {
                                  value: _vm.registerForm.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.registerForm, "password", $$v)
                                  },
                                  expression: "registerForm.password"
                                }
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    attrs: { slot: "suffix" },
                                    on: { click: _vm.showPass },
                                    slot: "suffix"
                                  },
                                  [
                                    _vm.passw == "password"
                                      ? _c("img", {
                                          staticClass: "reg-show-hide-icon",
                                          attrs: {
                                            src: require("../../assets/img/icon-hide.png"),
                                            alt: ""
                                          }
                                        })
                                      : _c("img", {
                                          staticClass: "reg-show-hide-icon",
                                          attrs: {
                                            src: require("../../assets/img/icon-show.png"),
                                            alt: ""
                                          }
                                        })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "form-info click-sign" }, [
                          _c("span", [
                            _vm._v("By clicking Sign up, you agree to our")
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.gourl("/term-service")
                                }
                              }
                            },
                            [_vm._v("Terms of Service")]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { staticClass: "reg-next" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: {
                                  type: "primary",
                                  disabled: _vm.reging
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.submitForm("registerForm")
                                  }
                                }
                              },
                              [_vm._v("Next")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "form-info have-acct" }, [
                          _c("span", [
                            _vm._v("Already have ShopVidi account？")
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  _vm.loginType = "login"
                                }
                              }
                            },
                            [_vm._v("Log in now")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("GoogleLogin", {
                          on: { googleCallBack: _vm.googleCallBack }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.step == 1
              ? _c(
                  "div",
                  { staticClass: "register-step1" },
                  [
                    _c("img", {
                      staticClass: "show",
                      attrs: {
                        src:
                          "https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"
                      }
                    }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("About your shop")]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n          Complete your profile so we can use AI Engine to help you pick the\n          best winning products\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      { attrs: { model: _vm.infoForm } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: _vm.labelObject.shopLabel } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "Select an option"
                                },
                                on: { change: _vm.changeOnlineShopTyoe },
                                model: {
                                  value: _vm.infoForm.onlineShopType,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.infoForm,
                                      "onlineShopType",
                                      $$v
                                    )
                                  },
                                  expression: "infoForm.onlineShopType"
                                }
                              },
                              _vm._l(_vm.onlineShop, function(item, id) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.showOnline
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.labelObject.shopPlatformLabel
                                }
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      clearable: "",
                                      placeholder: "Select an option"
                                    },
                                    model: {
                                      value: _vm.infoForm.shopPlatform,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.infoForm,
                                          "shopPlatform",
                                          $$v
                                        )
                                      },
                                      expression: "infoForm.shopPlatform"
                                    }
                                  },
                                  _vm._l(_vm.platform, function(item, id) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: id }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOnline
                          ? _c(
                              "el-form-item",
                              {
                                attrs: { label: _vm.labelObject.shopUrlLabel }
                              },
                              [
                                _c(
                                  "el-input",
                                  {
                                    attrs: { placeholder: "" },
                                    model: {
                                      value: _vm.infoForm.shopUrl,
                                      callback: function($$v) {
                                        _vm.$set(_vm.infoForm, "shopUrl", $$v)
                                      },
                                      expression: "infoForm.shopUrl"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "prepend" }, [
                                      _vm._v(" Http:// ")
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOffline
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.labelObject.storeAddressLabel
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "Enter Store Address",
                                    maxlength: "200"
                                  },
                                  model: {
                                    value: _vm.infoForm.storeAddress,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.infoForm,
                                        "storeAddress",
                                        $$v
                                      )
                                    },
                                    expression: "infoForm.storeAddress"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOffline
                          ? _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.labelObject.stateLabel
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Enter Store State",
                                            maxlength: "200"
                                          },
                                          model: {
                                            value: _vm.infoForm.state,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.infoForm,
                                                "state",
                                                $$v
                                              )
                                            },
                                            expression: "infoForm.state"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.labelObject.cityLabel
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Enter Store City",
                                            maxlength: "200"
                                          },
                                          model: {
                                            value: _vm.infoForm.city,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.infoForm,
                                                "city",
                                                $$v
                                              )
                                            },
                                            expression: "infoForm.city"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showOffline
                          ? _c(
                              "el-row",
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.labelObject.countryLabel
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Enter Store Country*",
                                            disabled: ""
                                          },
                                          model: {
                                            value: _vm.infoForm.country,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.infoForm,
                                                "country",
                                                $$v
                                              )
                                            },
                                            expression: "infoForm.country"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 12 } },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          label: _vm.labelObject.zipCodeLabel
                                        }
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "Enter Store Zipcode*",
                                            maxlength: "5",
                                            clearable: ""
                                          },
                                          on: { input: _vm.changeZipCode },
                                          model: {
                                            value: _vm.infoForm.zipCode,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.infoForm,
                                                "zipCode",
                                                $$v
                                              )
                                            },
                                            expression: "infoForm.zipCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { type: "primary" },
                                on: { click: _vm.submitInfo }
                              },
                              [_vm._v("Next")]
                            ),
                            _vm._v(" "),
                            _vm.showSkip
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "{\n                text-align": "center",
                                      cursor: "pointer",
                                      color: "#999",
                                      "margin-top": "20px"
                                    },
                                    on: { click: _vm.hidePop }
                                  },
                                  [_vm._v("\n              Skip\n            ")]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.step == 2
              ? _c(
                  "div",
                  { staticClass: "register-step1" },
                  [
                    _c("img", {
                      staticClass: "show",
                      attrs: {
                        src:
                          "https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png"
                      }
                    }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("About your shop")]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      { attrs: { model: _vm.infoForm } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "What kind of store do you have?" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "Select an option"
                                },
                                model: {
                                  value: _vm.infoForm.storeType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.infoForm, "storeType", $$v)
                                  },
                                  expression: "infoForm.storeType"
                                }
                              },
                              _vm._l(_vm.kind, function(item, id) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "What’s your annual turnover?" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "Select an option"
                                },
                                model: {
                                  value: _vm.infoForm.annualTurnover,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.infoForm,
                                      "annualTurnover",
                                      $$v
                                    )
                                  },
                                  expression: "infoForm.annualTurnover"
                                }
                              },
                              _vm._l(_vm.turnover, function(item, id) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "When did you open your store?" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "Select an option"
                                },
                                model: {
                                  value: _vm.infoForm.openYears,
                                  callback: function($$v) {
                                    _vm.$set(_vm.infoForm, "openYears", $$v)
                                  },
                                  expression: "infoForm.openYears"
                                }
                              },
                              _vm._l(_vm.openYear, function(item, id) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "Business Type?" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "Select an option"
                                },
                                model: {
                                  value: _vm.infoForm.businessType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.infoForm, "businessType", $$v)
                                  },
                                  expression: "infoForm.businessType"
                                }
                              },
                              _vm._l(_vm.businessTypeList, function(item, id) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "How did you hear About Us?" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  clearable: "",
                                  placeholder: "Select an option"
                                },
                                model: {
                                  value: _vm.infoForm.source,
                                  callback: function($$v) {
                                    _vm.$set(_vm.infoForm, "source", $$v)
                                  },
                                  expression: "infoForm.source"
                                }
                              },
                              _vm._l(_vm.sources, function(item, id) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: id }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Which categories are you interested in?"
                            }
                          },
                          [
                            _c(
                              "el-checkbox-group",
                              {
                                staticStyle: {
                                  display: "block",
                                  width: "100%"
                                },
                                on: { change: _vm.selectBox },
                                model: {
                                  value: _vm.infoForm.interestedCategory,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.infoForm,
                                      "interestedCategory",
                                      $$v
                                    )
                                  },
                                  expression: "infoForm.interestedCategory"
                                }
                              },
                              _vm._l(_vm.groupList, function(item, id) {
                                return _c(
                                  "el-checkbox",
                                  {
                                    key: item.id + "-" + item.cateName,
                                    attrs: {
                                      label: item.id + "-" + item.cateName,
                                      name: "type"
                                    }
                                  },
                                  [_vm._v(_vm._s(item.cateName))]
                                )
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "btn",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.submitForm("infoForm")
                                  }
                                }
                              },
                              [_vm._v("Submit")]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "text-align": "center",
                                  cursor: "pointer",
                                  color: "#8f8f8f",
                                  "margin-top": "20px"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.step = 1
                                  }
                                }
                              },
                              [_vm._v("\n              Back\n            ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b8e8fb4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b8e8fb4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/login.vue
// module id = null
// module chunks = 